// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconWishlist: React.FC = () => {
    const strokeColor = BLUEPRINT_NAME === "turnerBlueprint" ? "#D93D04" : "#1A4BA1";
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="currentColor">
            <g fill="none" fillRule="evenodd" strokeWidth={2}>
                <polygon
                    stroke={strokeColor}
                    fill="currentColor"
                    fillRule="nonzero"
                    points="2.18353271484375,24.357315063476562 9.433526992797852,19.783157348632812 16.683523178100586,24.357315063476562 16.683523178100586,3.4468765258789062 2.18353271484375,3.4468765258789062 "
                />
            </g>
        </svg>
    );
};

export default React.memo(IconWishlist);
